import { useMemo } from "react";
import { Flex, TabProps, Tabs, Text } from "@mantine/core";

import { IconStepper, IconStepperCompleted, IconStepperProgress } from "../../assets/icons";

export interface CreateCampaignInquiryTabProps extends TabProps {
    isActive: boolean;
    isCompleted: boolean;
    isLast: boolean;
    hasError?: boolean;
}

export const CreateCampaignInquiryTab = ({ isActive, isCompleted, isLast, hasError, children, ...rest }: CreateCampaignInquiryTabProps) => {
    const icon = useMemo(() => {
        if (isActive) {
            return (
                <IconStepperProgress hasError={hasError} />
            );
        }

        if (isCompleted) {
            return (
                <IconStepperCompleted hasError={hasError} />
            );
        }

        return (
            <IconStepper hasError={hasError} />
        );
    }, [isActive, isCompleted, hasError]);

    return (
        <Tabs.Tab
            {...rest}
            icon={
                <Flex style={{ position: "relative" }}>
                    {!isLast && (
                        <Flex
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                borderLeftWidth: 2,
                                borderLeftStyle: isCompleted ? "solid" : "dashed",
                                borderLeftColor: isCompleted ? "#30A9D4" : "#EEEFF2",
                                width: 2,
                                zIndex: 0,
                                height: 40,
                            }}
                        />
                    )}
                    <div style={{ position: "relative", zIndex: 1 }}>
                        {icon}
                    </div>
                </Flex>
            }
        >
            <Text
                size={14}
                weight={600}
                color={hasError ? "red" : undefined}
            >
                {children}
            </Text>
        </Tabs.Tab>
    );
};
